import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { OrgContextService } from '../user-context/org-context.service';

/** Header every compliance API call is scoped by (FDD §4.2). */
export const ORG_HEADER = 'X-Organization-Id';

/**
 * Scopes outbound API requests to the active organization by attaching
 * `X-Organization-Id` (FDD §4.2) — the backend requires it on org-scoped
 * endpoints. Added only when:
 *  - the request targets our API (never third-party hosts), and
 *  - an org is active (before org selection, e.g. /auth/me and /auth/switch-org,
 *    there is nothing to send), and
 *  - the request doesn't already set the header, so a caller that sets
 *    `X-Organization-Id` explicitly (targeting a specific org) always wins.
 */
export const orgHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = environment.API_URL;
  if (!apiUrl || !req.url.startsWith(apiUrl) || req.headers.has(ORG_HEADER)) {
    return next(req);
  }

  const orgId = inject(OrgContextService).activeOrg()?.orgId;
  if (orgId == null) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { [ORG_HEADER]: String(orgId) } }));
};
